import styled from "styled-components";

const Truncated = styled.span`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 0%;
`;

export default Truncated;
